// garuda - Transition Overlay Component

import React, { useState, useEffect } from "react";
import "./TransitionOverlay.css";

const TransitionOverlay = ({ message, isActive, onComplete }) => {
  const [phase, setPhase] = useState("hidden"); // hidden, fadeIn, showing, fadeOut

  useEffect(() => {
    if (!isActive) {
      setPhase("hidden");
      return;
    }

    // Phase 1: Fade in blank screen
    setPhase("fadeIn");

    const timer1 = setTimeout(() => {
      // Phase 2: Show message
      setPhase("showing");
    }, 400);

    const timer2 = setTimeout(() => {
      // Phase 3: Fade out
      setPhase("fadeOut");
    }, 1800);

    const timer3 = setTimeout(() => {
      // Phase 4: Complete
      setPhase("hidden");
      if (onComplete) onComplete();
    }, 2400);

    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
      clearTimeout(timer3);
    };
  }, [isActive, onComplete]);

  if (phase === "hidden") return null;

  return (
    <div className={`transition-overlay ${phase}`}>
      <div className="transition-message">{message}</div>
    </div>
  );
};

export default TransitionOverlay;
